import { render, staticRenderFns } from "./BlacklistEditor.vue?vue&type=template&id=22347666&"
import script from "./BlacklistEditor.vue?vue&type=script&lang=js&"
export * from "./BlacklistEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports